const themeColors = {
    blue: {
        primaryLight: '#E3F2FD',
        primaryMain: '#1976d2',
        primaryDark: '#1565C0',
        primary200: '#90CAF9',
        primary800: '#1565C0',

        secondaryLight: '#ede7f6',
        secondaryMain: '#673ab7',
        secondaryDark: '#5e35b1',
        secondary200: '#b39ddb',
        secondary800: '#4527a0'
    },

    green: {
        primaryLight: '#E8F5E9',
        primaryMain: '#2e7d32',
        primaryDark: '#1b5e20',
        primary200: '#A5D6A7',
        primary800: '#1b5e20',

        secondaryLight: '#E0F2F1',
        secondaryMain: '#00897B',
        secondaryDark: '#00695C',
        secondary200: '#80CBC4',
        secondary800: '#004D40'
    },

    orange: {
        primaryLight: '#fef3e0',
        primaryMain: '#f07c00',
        primaryDark: '#e15200',
        primary200: '#fccb80',
        primary800: '#ea6c00',

        // secondary
        secondaryLight: '#fef3e0',
        secondaryMain: '#f07c00',
        secondaryDark: '#e15200',
        secondary200: '#fef3e0',
        secondary800: '#43484b'
    },

    red: {
        primaryLight: '#FFEBEE',
        primaryMain: '#d32f2f',
        primaryDark: '#b71c1c',
        primary200: '#EF9A9A',
        primary800: '#c62828',

        secondaryLight: '#FCE4EC',
        secondaryMain: '#e91e63',
        secondaryDark: '#ad1457',
        secondary200: '#F48FB1',
        secondary800: '#880E4F'
    },

    purple: {
        primaryLight: '#F3E5F5',
        primaryMain: '#7b1fa2',
        primaryDark: '#4a148c',
        primary200: '#CE93D8',
        primary800: '#6a1b9a',

        secondaryLight: '#EDE7F6',
        secondaryMain: '#5e35b1',
        secondaryDark: '#4527a0',
        secondary200: '#B39DDB',
        secondary800: '#311B92'
    },

    pink: {
        primaryLight: '#FCE4EC',
        primaryMain: '#c2185b',
        primaryDark: '#880e4f',
        primary200: '#F48FB1',
        primary800: '#ad1457',

        secondaryLight: '#F3E5F5',
        secondaryMain: '#ab47bc',
        secondaryDark: '#8e24aa',
        secondary200: '#CE93D8',
        secondary800: '#6A1B9A'
    },

    teal: {
        primaryLight: '#E0F2F1',
        primaryMain: '#00897b',
        primaryDark: '#004d40',
        primary200: '#80CBC4',
        primary800: '#00695c',

        secondaryLight: '#E0F7FA',
        secondaryMain: '#00ACC1',
        secondaryDark: '#00838F',
        secondary200: '#80DEEA',
        secondary800: '#006064'
    },

    indigo: {
        primaryLight: '#E8EAF6',
        primaryMain: '#3949ab',
        primaryDark: '#1a237e',
        primary200: '#9FA8DA',
        primary800: '#283593',

        secondaryLight: '#E1F5FE',
        secondaryMain: '#1E88E5',
        secondaryDark: '#1565C0',
        secondary200: '#90CAF9',
        secondary800: '#0D47A1'
    },

    cyan: {
        primaryLight: '#E0F7FA',
        primaryMain: '#00acc1',
        primaryDark: '#006064',
        primary200: '#80DEEA',
        primary800: '#00838f',

        secondaryLight: '#E8F5E9',
        secondaryMain: '#43A047',
        secondaryDark: '#2E7D32',
        secondary200: '#A5D6A7',
        secondary800: '#1B5E20'
    },

    brown: {
        primaryLight: '#EFEBE9',
        primaryMain: '#6d4c41',
        primaryDark: '#3e2723',
        primary200: '#BCAAA4',
        primary800: '#4e342e',

        secondaryLight: '#FFF3E0',
        secondaryMain: '#fb8c00',
        secondaryDark: '#ef6c00',
        secondary200: '#FFCC80',
        secondary800: '#E65100'
    },

    darkBlue: {
        primaryLight: '#263238',
        primaryMain: '#102a43',
        primaryDark: '#0b1f33',
        primary200: '#486581',
        primary800: '#0b1f33',

        secondaryLight: '#1F2937',
        secondaryMain: '#374151',
        secondaryDark: '#111827',
        secondary200: '#6B7280',
        secondary800: '#030712'
    }
};

export default themeColors;
